var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade", appear: "" } }, [
    _vm.showAlert && _vm.whereIsRendered === _vm.alert.componentWhereIsRendered
      ? _c(
          "div",
          {
            class: [
              _vm.getType,
              "alert-container",
              {
                "render-at-the-bottom": _vm.renderAtTheBottom,
                "login-view": _vm.renderAtLoginView,
              },
            ],
          },
          [_c("span", { class: [_vm.getIcon, "alert-icon"] })]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }